export function formatDateLabel (dateLabel) {
  let dateLabelToArray = dateLabel.split(',')
  dateLabelToArray[0] = dateLabelToArray[0].substr(0, 3)
  let dayAndDateToArray = dateLabelToArray[1].split(' ')
  dayAndDateToArray[1] = dayAndDateToArray[1].substr(0, 3)
  dateLabelToArray[1] = dayAndDateToArray.join(' ')

  return dateLabelToArray.join(',')
}

export function getCreatedAt (paymentCreatedAt) {
  let date = new Date(paymentCreatedAt)
  return date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
}



// WEBPACK FOOTER //
// ./app/pages/Reports/Transaction/formatter.js